import { promisifiedResult, Result } from '@/lib/monads'

export type Prediction = {
  placeId: string
  mainText: string
  secondaryText: string
  description: string
}

export type Place = {
  placeId?: string
  location: {
    lat?: number
    lng?: number
  }
  name?: string
  formattedAddress?: string
}

export function getPlacePredictions(input: string): Promise<Prediction[]> {
  const autocompleteService = new google.maps.places.AutocompleteService()
  return autocompleteService
    .getPlacePredictions({ input })
    .then(({ predictions }) =>
      predictions.map(prediction => ({
        placeId: prediction.place_id,
        mainText: prediction.structured_formatting.main_text,
        secondaryText: prediction.structured_formatting.secondary_text,
        description: prediction.description,
      }))
    )
}

export function getDetail({
  placeId,
  map,
}: {
  placeId: string
  map: google.maps.Map
}): Promise<Result<Place | null, Error>> {
  const newService = new google.maps.places.PlacesService(map)
  return promisifiedResult(res => {
    newService.getDetails({ placeId }, data =>
      res(
        data
          ? {
              placeId: data.place_id,
              location: {
                lat: data.geometry?.location?.lat(),
                lng: data.geometry?.location?.lng(),
              },
              name: data.name,
              formattedAddress: data.formatted_address,
            }
          : data
      )
    )
  })
}
